import { render } from "./SLAInfoDocked.vue?vue&type=template&id=5c570e7a&scoped=true"
import script from "./SLAInfoDocked.vue?vue&type=script&lang=js"
export * from "./SLAInfoDocked.vue?vue&type=script&lang=js"

import "./SLAInfoDocked.vue?vue&type=style&index=0&id=5c570e7a&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c570e7a"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import qInstall from "../../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QInnerLoading});
